<template>
  <div class="about-page">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="container">
        <h1 class="page-title">关于我们</h1>
        <p class="page-subtitle">创新科技，改善生活 - 为残障人士提供专业的无障碍解决方案</p>
      </div>
    </div>

    <!-- 公司理念 -->
    <section class="company-mission">
      <div class="container">
        <div class="mission-content">
          <div class="mission-text">
            <h2>我们的使命</h2>
            <p class="mission-description">
              我们的核心使命始终是关注产品和服务的使用者 - 通过提供最适合他们需求的解决方案，为他们带来独立自主的生活。
            </p>
            <p class="mission-description">
              在医疗科技，我们将使用我们产品的人放在首位。我们的目标是为个人创新；创造先进的辅助解决方案，让残障人士的生活更加丰富多彩。我们的专业团队不懈努力实现这一目标，无论是设计新的轮椅、测试座椅垫，还是支持治疗师。
            </p>
          </div>
          <div class="mission-image">
            <img src="https://via.placeholder.com/500x400?text=公司使命" alt="公司使命" />
          </div>
        </div>
      </div>
    </section>

    <!-- 公司历史 -->
    <section class="company-history">
      <div class="container">
        <div class="history-content">
          <div class="history-image">
            <img src="https://via.placeholder.com/500x400?text=公司历史" alt="公司历史" />
          </div>
          <div class="history-text">
            <h2>我们的历史</h2>
            <p class="history-description">
              我们的创始人热衷于为行动不便的人提供更好的生活，这种热情至今仍在医疗科技的每个人心中流淌。
            </p>
            <p class="history-description">
              现在，这驱使我们突破技术和自身创造力的界限，追求能够改善用户生活质量的创新。正如用户的需求不断变化，我们也持续努力调整我们的产品，以满足他们的日常现实需求。
            </p>
            <div class="history-stats">
              <div class="stat-item">
                <span class="stat-number">1967</span>
                <span class="stat-label">成立年份</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">50+</span>
                <span class="stat-label">年专业经验</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">100+</span>
                <span class="stat-label">个国家服务</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 创新理念 -->
    <section class="innovation-section">
      <div class="container">
        <div class="innovation-content">
          <h2>基于临床数据的创新</h2>
          <p class="innovation-description">
            感谢这一点，我们的用户可以信任我们提供市场领先的解决方案，这些解决方案通过与基于临床数据的洞察合作而向前推进 - 我们称之为基于证据的创新。
          </p>
          <div class="innovation-features">
            <div class="feature-card">
              <div class="feature-icon">🔬</div>
              <h3>临床研究</h3>
              <p>与医疗专家合作，基于临床数据进行产品研发</p>
            </div>
            <div class="feature-card">
              <div class="feature-icon">🎯</div>
              <h3>个性化定制</h3>
              <p>为每个用户提供量身定制的解决方案</p>
            </div>
            <div class="feature-card">
              <div class="feature-icon">⚡</div>
              <h3>技术创新</h3>
              <p>持续推动技术边界，创造前沿产品</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心价值观 -->
    <section class="values-section">
      <div class="container">
        <h2>我们的核心价值观</h2>
        <div class="values-grid">
          <div class="value-card">
            <div class="value-icon">👥</div>
            <h3>以人为本</h3>
            <p>将用户需求放在首位，创造真正改善生活的产品</p>
          </div>
          <div class="value-card">
            <div class="value-icon">🔍</div>
            <h3>看见能力</h3>
            <p>我们看见能力，而不是限制，帮助每个人发挥潜能</p>
          </div>
          <div class="value-card">
            <div class="value-icon">🚀</div>
            <h3>引领变革</h3>
            <p>在辅助技术领域引领创新，推动行业发展</p>
          </div>
          <div class="value-card">
            <div class="value-icon">🤝</div>
            <h3>为个人创新</h3>
            <p>为每个独特的个体创造个性化的解决方案</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品系列 -->
    <section class="products-overview">
      <div class="container">
        <h2>我们的产品系列</h2>
        <div class="products-grid">
          <div class="product-category">
            <div class="category-icon">⚡</div>
            <h3>电动轮椅</h3>
            <p>智能控制系统，舒适座椅，长续航能力</p>
          </div>
          <div class="product-category">
            <div class="category-icon">🦽</div>
            <h3>手动轮椅</h3>
            <p>轻量化设计，便于携带，经济实用</p>
          </div>
          <div class="product-category">
            <div class="category-icon">🪑</div>
            <h3>座椅定位</h3>
            <p>专业坐垫，防褥疮设计，舒适支撑</p>
          </div>
          <div class="product-category">
            <div class="category-icon">🔧</div>
            <h3>辅助配件</h3>
            <p>安全设备，实用配件，提升使用体验</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="contact-section">
      <div class="container">
        <div class="contact-content">
          <h2>联系我们</h2>
          <p>我们致力于为每个用户提供最好的解决方案。如果您有任何问题或需要咨询，请随时联系我们。</p>
          <div class="contact-info">
            <div class="contact-item">
              <div class="contact-icon">📞</div>
              <div class="contact-details">
                <h4>客服热线</h4>
                <p>400-123-4567</p>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">📧</div>
              <div class="contact-details">
                <h4>邮箱地址</h4>
                <p>info@medicaltech.com</p>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">📍</div>
              <div class="contact-details">
                <h4>公司地址</h4>
                <p>北京市朝阳区科技园区123号</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'About',
  mounted() {
    this.initScrollAnimations();
  },
  methods: {
    initScrollAnimations() {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-on-scroll');
          }
        });
      }, observerOptions);

      document.querySelectorAll('.mission-content, .history-content, .feature-card, .value-card, .product-category').forEach(el => {
        observer.observe(el);
      });
    }
  }
}
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  background: #f8f9fa;
}

.page-header {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a7bc8 100%);
  color: white;
  padding: 4rem 2rem;
  text-align: center;
}

.page-title {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: 300;
}

.page-subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 公司理念 */
.company-mission {
  padding: 5rem 0;
  background: white;
}

.mission-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.mission-text h2 {
  font-size: 2.5rem;
  color: #2c5aa0;
  margin-bottom: 2rem;
  font-weight: 300;
}

.mission-description {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #666;
  margin-bottom: 1.5rem;
}

.mission-image img {
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.1);
}

/* 公司历史 */
.company-history {
  padding: 5rem 0;
  background: #f8f9fa;
}

.history-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.history-content .history-image {
  order: 2;
}

.history-content .history-text {
  order: 1;
}

.history-text h2 {
  font-size: 2.5rem;
  color: #2c5aa0;
  margin-bottom: 2rem;
  font-weight: 300;
}

.history-description {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #666;
  margin-bottom: 1.5rem;
}

.history-image img {
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.1);
}

.history-stats {
  display: flex;
  gap: 2rem;
  margin-top: 2rem;
}

.stat-item {
  text-align: center;
}

.stat-number {
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: #2c5aa0;
}

.stat-label {
  font-size: 0.9rem;
  color: #666;
}

/* 创新理念 */
.innovation-section {
  padding: 5rem 0;
  background: white;
}

.innovation-content {
  text-align: center;
}

.innovation-content h2 {
  font-size: 2.5rem;
  color: #2c5aa0;
  margin-bottom: 2rem;
  font-weight: 300;
}

.innovation-description {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #666;
  max-width: 800px;
  margin: 0 auto 3rem;
}

.innovation-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.feature-card {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 16px;
  text-align: center;
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0,0,0,0.1);
}

.feature-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.feature-card h3 {
  font-size: 1.3rem;
  color: #2c5aa0;
  margin-bottom: 1rem;
}

.feature-card p {
  color: #666;
  line-height: 1.6;
}

/* 核心价值观 */
.values-section {
  padding: 5rem 0;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a7bc8 100%);
  color: white;
}

.values-section h2 {
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  font-weight: 300;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.value-card {
  background: rgba(255,255,255,0.1);
  padding: 2rem;
  border-radius: 16px;
  text-align: center;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.value-card:hover {
  transform: translateY(-5px);
  background: rgba(255,255,255,0.2);
}

.value-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.value-card h3 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
}

.value-card p {
  line-height: 1.6;
  opacity: 0.9;
}

/* 产品系列 */
.products-overview {
  padding: 5rem 0;
  background: white;
}

.products-overview h2 {
  font-size: 2.5rem;
  text-align: center;
  color: #2c5aa0;
  margin-bottom: 3rem;
  font-weight: 300;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.product-category {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 16px;
  text-align: center;
  transition: all 0.3s ease;
}

.product-category:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0,0,0,0.1);
}

.category-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.product-category h3 {
  font-size: 1.3rem;
  color: #2c5aa0;
  margin-bottom: 1rem;
}

.product-category p {
  color: #666;
  line-height: 1.6;
}

/* 联系我们 */
.contact-section {
  padding: 5rem 0;
  background: #f8f9fa;
}

.contact-content {
  text-align: center;
}

.contact-content h2 {
  font-size: 2.5rem;
  color: #2c5aa0;
  margin-bottom: 2rem;
  font-weight: 300;
}

.contact-content > p {
  font-size: 1.1rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto 3rem;
  line-height: 1.8;
}

.contact-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.contact-item {
  background: white;
  padding: 2rem;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
}

.contact-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 30px rgba(0,0,0,0.12);
}

.contact-icon {
  font-size: 2rem;
  color: #2c5aa0;
}

.contact-details h4 {
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 0.5rem;
}

.contact-details p {
  color: #666;
}

/* 动画效果 */
.animate-on-scroll {
  animation: fadeInUp 0.8s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-title {
    font-size: 2rem;
  }
  
  .mission-content,
  .history-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .history-content .history-image {
    order: 1;
  }
  
  .history-content .history-text {
    order: 2;
  }
  
  .history-stats {
    flex-direction: column;
    gap: 1rem;
  }
  
  .innovation-features,
  .values-grid,
  .products-grid {
    grid-template-columns: 1fr;
  }
  
  .contact-info {
    grid-template-columns: 1fr;
  }
}
</style> 